module.exports = __webpack_public_path__ + "static/GameSound-7f1bc3b3721398e8988e6215ea7a9f49.mp3";